'use strict'
export default function () {
	if(document.body.classList.contains('homepage')){
    const video = document.querySelector('#main-video video')
    const heightNavBar = document.getElementById('main-nav').clientHeight
    const widthWindow = window.innerWidth;
    const heightWindow = window.innerHeight;

	let heightVideo = heightWindow - heightNavBar
		if (widthWindow/16 >= heightWindow/9) {
			video.setAttribute('width', widthWindow);
			video.setAttribute('height', 'auto');
		} else {
			video.setAttribute('width', 'auto');
			video.setAttribute('height', heightVideo);
		}
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scaleVideo.js